<template>
  <v-chip small color="bhGray6">
    <span :class="`dot-status__dot dot-status__dot--${statusClass}`"></span>
    {{ statusName }}
  </v-chip>
</template>

<script>
export default {
  name: 'DotStatus',
  props: {
    status: {
      type: Object,
      required: true,
    },
    enrolled: {
      type: [Boolean, undefined],
      required: false,
      default: undefined,
    },
    completePercentage: {
      type: Number,
      required: true,
    },
    progress: {
      type: Number,
      required: false,
    },
    total: {
      type: Number,
      required: false,
    },
  },

  computed: {
    isInProgress() {
      return this.progress !== undefined && this.total !== undefined
    },
    statusClass() {
      if (this.enrolled !== undefined && !this.enrolled) {
        return 'not-enrolled'
      }
      return this.status && this.status.done ? 'done' : 'in-progress'
    },
    statusName() {
      if (this.enrolled !== undefined && !this.enrolled) {
        return 'Not enrolled'
      }
      return this.status && this.status.done
        ? 'Completed'
        : `In progress - ${this.completePercentage}% ${
            this.isInProgress ? `- ${this.progress}/${this.total}` : ''
          }`
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';
.dot-status {
  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    margin-right: 6px;
    background-color: transparent;

    &--done {
      background-color: var(--bh-green);
    }

    &--in-progress {
      background-color: var(--bh-yellow);
    }

    &--not-enrolled {
      background-color: var(--bh-gray);
    }
  }
}
</style>
